import { takeLatest, call, put } from 'redux-saga/effects'
import coursesList from 'api/administration/courses/GetList'
import * as fromActions from '../../actions/courses.action'

function* coursesListEffectSaga(action: any) {
  try {
    const {
      page,
      searchText,
      sort,
      usersFilter,
      perPage: itemsPerPage,
      fastFilters,
    } = action.payload
    const { data, total, perPage } = yield call(
      coursesList,
      page,
      searchText,
      sort,
      usersFilter,
      itemsPerPage,
      fastFilters
    )
    yield put(
      fromActions.Actions.coursesAdministrationListSuccess(
        data,
        total,
        perPage,
        sort
      )
    )
  } catch (error) {
    console.error('coursesListEffectSaga error: ', error)
    yield put(fromActions.Actions.setCourseLoading(false))
  }
}

export function* coursesListWatcherSaga() {
  yield takeLatest(
    fromActions.COURSES_ADMINISTRATION_GET_LIST,
    coursesListEffectSaga
  )
}
